import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';

import Layout from '@/components/layout/Layout';
import Home from '@/pages/Home';
import WomensDesign from '@/pages/WomensDesign';
import MensBespoke from '@/pages/MensBespoke';
import OurStory from '@/pages/OurStory';
import BookAppointment from '@/pages/BookAppointment';
import Contact from '@/pages/Contact';
import Testimonials from '@/pages/Testimonials';
import Sale from '@/pages/Sale';
import ComingSoon from '@/pages/ComingSoon';
import { Toaster } from '@/components/ui/sonner';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/womens-design" element={<WomensDesign />} />
            <Route path="/womens-design/:slug" element={<ComingSoon />} />
            <Route path="/mens-bespoke" element={<MensBespoke />} />
            <Route path="/mens-bespoke/:slug" element={<ComingSoon />} />
            <Route path="/our-story" element={<OurStory />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/sale" element={<Sale />} />
            <Route path="/book-appointment" element={<BookAppointment />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<ComingSoon />} />
          </Routes>
        </Layout>
        <Toaster position="bottom-center" richColors closeButton theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
